export default {"src":"/_next/static/media/Arrow-down.b162a226.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};